<app-slide-dialog-layout (dismissed)="dismiss()">
    <div left [translate]="'CLOSE'" i18n="@@CLOSE">Close</div>
    <div title [translate]="'BECOME_BETA_TESTER'" i18n="@@BECOME_BETA_TESTER">Become Beta tester</div>

    <div class="space-y-4" dcTypography="geist-14" dcColor="bullseye-black">
        <div [translate]="'BETA_OPT_IN_OMNI_INFO'" i18n="@@BETA_OPT_IN_OMNI_INFO">
            Want to be the first to try new features? By joining the beta program, you'll gain early access to
            experimental features of the Omni before they're released to the public.
        </div>
        <p class="italic" [translate]="'BETA_POTENTIAL_BUG_NOTICE'" i18n="@@BETA_POTENTIAL_BUG_NOTICE">
            Please note: beta versions are experimental and may contain bugs, incomplete features, or occasional
            performance issues. The beta is intended for users who are comfortable testing new functionality and sharing
            feedback.
        </p>
        <p [translate]="'YOU_CAN_OPT_OUT_OF_BETA'" i18n="@@YOU_CAN_OPT_OUT_OF_BETA">
            You can opt out of the beta at any time and return to the stable version.
        </p>

        @if (isLoading()) {
            <div class="flex justify-center py-4">
                <dc-loading-spinner size="medium"></dc-loading-spinner>
            </div>
        } @else {
            <button
                type="button"
                class="!mt-8 w-full"
                dcButton
                dcBgColor="oche-orange"
                (click)="isBeta() ? leaveBeta() : joinBeta()">
                @if (isBeta()) {
                    <span [translate]="'LEAVE_BETA'" i18n="@@LEAVE_BETA">Leave the beta</span>
                } @else {
                    <span [translate]="'JOIN_BETA'" i18n="@@JOIN_BETA">Join the beta</span>
                }
            </button>
        }
    </div>
</app-slide-dialog-layout>
